module.exports = __webpack_public_path__ + "3ccb15187ed9745de75d931816f1788a.jpg";